/* TK 2026-10-15 — vlastní modal recenze místo Judge.me lightboxu.

   Otevírá se klikem na kartu recenze (.jm-review-item), na fotku v kartě
   (.jm-media-thumbnail-list__thumbnail) i na fotku v hlavičce widgetu
   (.jm-media-grid__item). Klik se zachytí v CAPTURE fázi na documentu, takže
   se Judge.me handler (Vue onClick na prvku) vůbec nespustí.
   Data čte z vykreslené karty (jméno, datum, hvězdy, text, fotky, „Recenze
   pro"), takže sedí i překlad, který si zákazník v kartě přepnul.
   Recenze s VIDEEM nechává Judge.me (jeho lightbox umí přehrávač).
   Fotky: Judge.me dává do karty náhled `…original.jpg?quality=80&width=160`,
   do modalu se bere stejná adresa s width=1600.
   Vzhled: assets/tk-product-tabs.css, blok „Modal recenze (.tk-rvm)".
   Texty: window.__tkProductTabs.rvModal (sections/product-tabs.liquid). */
(function () {
  'use strict';

  var WIDGET = '#judgeme_product_reviews';
  var L = (window.__tkProductTabs || {}).rvModal || {};
  var STAR_PATH = 'M12 2.6l2.85 5.98 6.55.78-4.84 4.5 1.27 6.5L12 17.1l-5.83 3.26 1.27-6.5-4.84-4.5 6.55-.78z';
  var ICON_CLOSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHECK = '<svg viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="7" fill="#CED720"/><path d="M4 7.3 6.1 9.4 10 5.1" fill="none" stroke="#0A0A0A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var dlg = null;
  var ui = {};
  var mqMobile = window.matchMedia('(max-width: 749px)');
  var state = { media: [], index: 0, opener: null, scrollRaf: 0, gallery: false, panelItem: null, target: null, targetTimer: 0 };

  function urlWithWidth(src, width) {
    try {
      var u = new URL(src, location.href);
      if (/judgeme/.test(u.hostname)) {
        u.searchParams.set('width', String(width));
        u.searchParams.set('quality', '85');
      }
      return u.href;
    } catch (e) {
      return src;
    }
  }

  function mediaKey(src) {
    try {
      var u = new URL(src, location.href);
      return u.hostname + u.pathname;
    } catch (e) {
      return src;
    }
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html) n.innerHTML = html;
    return n;
  }

  function starsHtml(rating) {
    var full = Math.round(rating);
    var h = '';
    for (var i = 1; i <= 5; i++) {
      h += '<svg viewBox="0 0 24 24" aria-hidden="true"' + (i <= full ? ' class="is-on"' : '') + '><path d="' + STAR_PATH + '"/></svg>';
    }
    return h;
  }

  function hasVideo(scope) {
    return !!scope.querySelector('.jm-media-thumbnail-list__play-icon, .jm-media-grid__play-icon, video, iframe');
  }

  /* ── data z karty ─────────────────────────────────────────────────────── */
  function readItem(item) {
    var q = function (s) { return item.querySelector(s); };
    var starEl = q('.jm-star-rating');
    var m = starEl && /(\d+(?:[.,]\d+)?)/.exec(starEl.getAttribute('aria-label') || '');
    var nameEl = q('.jm-reviewer-info__name');
    var initialEl = q('.jm-reviewer-avatar__initial');
    var avatarImg = q('.jm-reviewer-avatar img');
    var dateEl = null;
    item.querySelectorAll('.jm-reviewer-info__details .jm-text').forEach(function (t) {
      if (!t.classList.contains('jm-reviewer-info__name') && !t.closest('.tk-verified-badge') && t.textContent.trim()) dateEl = t;
    });
    var badge = q('.tk-verified-badge, .jm-verified-buyer-badge');
    var titleEl = q('.jm-review-content__title');
    var bodyEl = q('.jdgm-review-content__body-content') || q('.jm-review-content__body');
    var replyEl = q('.jm-shop-reply');
    var linkEl = q('.jm-product-variant-card__product-link');
    var prodImg = q('.jm-product-variant-card__thumbnail img');
    var media = [];
    item.querySelectorAll('.jm-media-thumbnail-list__thumbnail img').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      media.push({ thumb: urlWithWidth(src, 240), full: urlWithWidth(src, 1600), key: mediaKey(src) });
    });
    return {
      rating: m ? parseFloat(m[1].replace(',', '.')) : 5,
      name: nameEl ? nameEl.textContent.trim() : '',
      initial: initialEl ? initialEl.textContent.trim() : (nameEl ? nameEl.textContent.trim().charAt(0) : ''),
      avatar: avatarImg ? avatarImg.getAttribute('src') : '',
      date: dateEl ? dateEl.textContent.trim() : '',
      verified: badge ? (badge.getAttribute('data-tk-tip') || badge.textContent.trim() || (window.__tkProductTabs || {}).verifiedLabel || '') : '',
      title: titleEl ? titleEl.textContent.trim() : '',
      body: bodyEl,
      reply: replyEl,
      product: linkEl ? { href: linkEl.getAttribute('href'), title: linkEl.textContent.trim(), img: prodImg ? prodImg.getAttribute('src') : '' } : null,
      media: media
    };
  }

  /* ── stavba dialogu (jednou) ──────────────────────────────────────────── */
  function build() {
    dlg = el('dialog', 'tk-rvm');
    dlg.setAttribute('aria-labelledby', 'tk-rvm-title');
    dlg.innerHTML =
      '<div class="tk-rvm__shell" tabindex="-1" autofocus>'
      + '<button type="button" class="tk-rvm__close">' + ICON_CLOSE + '</button>'
      + '<div class="tk-rvm__media">'
      + '<div class="tk-rvm__stage">'
      + '<div class="tk-rvm__track" tabindex="-1"></div>'
      + '<button type="button" class="tk-rvm__nav tk-rvm__nav--prev">' + ICON_PREV + '</button>'
      + '<button type="button" class="tk-rvm__nav tk-rvm__nav--next">' + ICON_NEXT + '</button>'
      + '<span class="tk-rvm__count" aria-hidden="true"></span>'
      + '</div>'
      + '<div class="tk-rvm__thumbs"></div>'
      + '</div>'
      + '<article class="tk-rvm__panel">'
      + '<header class="tk-rvm__who"><span class="tk-rvm__avatar"></span><span class="tk-rvm__meta"><span class="tk-rvm__name"></span><span class="tk-rvm__date"></span></span></header>'
      + '<div class="tk-rvm__stars" role="img"></div>'
      + '<h2 class="tk-rvm__title" id="tk-rvm-title"></h2>'
      + '<div class="tk-rvm__body"></div>'
      + '<div class="tk-rvm__reply"></div>'
      + '<a class="tk-rvm__product"><img alt="" width="44" height="44" loading="lazy"><span class="tk-rvm__product-title"></span></a>'
      + '</article>'
      + '</div>';
    document.body.appendChild(dlg);

    ['shell', 'media', 'stage', 'track', 'thumbs', 'count', 'panel', 'avatar', 'name', 'date', 'stars', 'title', 'body', 'reply', 'product', 'close'].forEach(function (k) {
      ui[k] = dlg.querySelector('.tk-rvm__' + k);
    });
    ui.prev = dlg.querySelector('.tk-rvm__nav--prev');
    ui.next = dlg.querySelector('.tk-rvm__nav--next');
    ui.close.setAttribute('aria-label', L.close || 'Close');
    ui.prev.setAttribute('aria-label', L.prev || 'Previous');
    ui.next.setAttribute('aria-label', L.next || 'Next');

    ui.close.addEventListener('click', close);
    ui.prev.addEventListener('click', function () { go(state.index - 1, true); });
    ui.next.addEventListener('click', function () { go(state.index + 1, true); });
    // klik mimo obsah (na plochu dialogu za shellem) zavře
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', onClosed);
    window.addEventListener('resize', function () { if (dlg.open) fitStage(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(state.index - 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { go(state.index + 1, true); e.preventDefault(); }
    });
    // swipe = nativní scroll-snap; index se dopočítá ze scrollu. Během
    // programového posunu (šipka, náhled) se mezipozice ignorují, jinak by
    // panel při skoku o víc fotek probliknul recenzemi, přes které pás jede.
    ui.track.addEventListener('scroll', function () {
      cancelAnimationFrame(state.scrollRaf);
      state.scrollRaf = requestAnimationFrame(function () {
        var i = trackIndex();
        if (state.target !== null) {
          if (i === state.target) endProgrammatic();
          return;
        }
        if (i !== state.index) { state.index = i; sync(); }
      });
    }, { passive: true });
    ui.track.addEventListener('scrollend', function () {
      if (state.target === null) return;
      endProgrammatic();
      var i = trackIndex();
      if (i !== state.index) { state.index = i; sync(); }
    });
  }

  function fillPanel(data) {
    ui.avatar.textContent = '';
    if (data.avatar) {
      var a = el('img');
      a.src = data.avatar;
      a.alt = '';
      ui.avatar.appendChild(a);
    } else {
      ui.avatar.textContent = (data.initial || '?').toUpperCase();
    }
    ui.name.textContent = data.name;
    if (data.verified) {
      var v = el('span', 'tk-rvm__verified', CHECK);
      v.setAttribute('title', data.verified);
      v.setAttribute('aria-label', data.verified);
      ui.name.appendChild(v);
    }
    ui.date.textContent = data.date;
    ui.stars.innerHTML = starsHtml(data.rating);
    ui.stars.setAttribute('aria-label', String(data.rating).replace('.', ',') + ' / 5');
    ui.title.textContent = data.title;
    ui.title.hidden = !data.title;
    ui.body.textContent = '';
    if (data.body) ui.body.appendChild(data.body.cloneNode(true));
    ui.reply.textContent = '';
    if (data.reply) ui.reply.appendChild(data.reply.cloneNode(true));
    ui.reply.hidden = !data.reply;
    if (data.product) {
      ui.product.href = data.product.href;
      ui.product.querySelector('.tk-rvm__product-title').textContent = data.product.title;
      // nový <img> místo změny src: prohlížeč by jinak do načtení nového
      // obrázku ukazoval předchozí produkt (černá → oranžová problikne)
      var oldImg = ui.product.querySelector('img');
      var pi = oldImg.cloneNode(false);
      pi.removeAttribute('src');
      if (data.product.img) { pi.src = data.product.img; pi.hidden = false; } else { pi.hidden = true; }
      oldImg.replaceWith(pi);
      ui.product.hidden = false;
    } else {
      ui.product.hidden = true;
    }
  }

  function fillMedia(media, start) {
    state.media = media;
    ui.track.textContent = '';
    ui.thumbs.textContent = '';
    media.forEach(function (m, i) {
      var slide = el('figure', 'tk-rvm__slide');
      var img = el('img');
      img.alt = '';
      img.decoding = 'async';
      img.loading = Math.abs(i - start) <= 1 ? 'eager' : 'lazy';
      img.addEventListener('load', function () { if (i === state.index) fitStage(); });
      img.src = m.full;
      slide.appendChild(img);
      ui.track.appendChild(slide);

      var t = el('button', 'tk-rvm__thumb');
      t.type = 'button';
      t.setAttribute('aria-label', (L.goTo || '__N__').replace('__N__', String(i + 1)));
      var ti = el('img');
      ti.alt = '';
      ti.loading = 'lazy';
      ti.src = m.thumb;
      t.appendChild(ti);
      t.addEventListener('click', function () { go(i, true); });
      ui.thumbs.appendChild(t);
    });
    ui.thumbs.hidden = media.length < 2;
  }

  /* Galerie z hlavičky: každá fotka nese svou kartu (m.item), panel vpravo
     se přepne na recenzi aktuální fotky. Fotka bez karty v DOM (jiná stránka
     paginace) = panel skrytý, jen fotka. */
  function syncPanel() {
    if (!state.gallery) return;
    var m = state.media[state.index];
    var it = m ? m.item || null : null;
    if (it === state.panelItem) return;
    state.panelItem = it;
    if (it) fillPanel(readItem(it));
    ui.panel.hidden = !it;
    dlg.classList.toggle('tk-rvm--photos', !it);
    ui.panel.scrollTop = 0;
  }

  /* Mobil: výška plochy s fotkou podle poměru AKTUÁLNÍ fotky (na šířku = celá
     šířka bez šedých pruhů), strop 62 % výšky okna, ať je recenze pod fotkou
     vidět. Desktop má pevnou plochu, výšku nechá CSS. */
  function fitStage() {
    if (!ui.stage) return;
    if (!mqMobile.matches || !state.media.length) { ui.stage.style.height = ''; return; }
    var slide = ui.track.children[state.index];
    var img = slide && slide.querySelector('img');
    if (!img || !img.naturalWidth) return;
    var h = Math.round(ui.stage.clientWidth * img.naturalHeight / img.naturalWidth);
    ui.stage.style.height = Math.max(200, Math.min(h, Math.round(window.innerHeight * 0.62))) + 'px';
  }

  function sync() {
    syncPanel();
    fitStage();
    var n = state.media.length;
    ui.count.textContent = n > 1 ? (state.index + 1) + ' / ' + n : '';
    ui.prev.hidden = ui.next.hidden = n < 2;
    ui.prev.disabled = state.index <= 0;
    ui.next.disabled = state.index >= n - 1;
    ui.thumbs.querySelectorAll('.tk-rvm__thumb').forEach(function (t, i) {
      var on = i === state.index;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var act = ui.thumbs.children[state.index];
    if (act && ui.thumbs.scrollWidth > ui.thumbs.clientWidth) {
      ui.thumbs.scrollTo({ left: act.offsetLeft - (ui.thumbs.clientWidth - act.offsetWidth) / 2, behavior: 'smooth' });
    }
  }

  function trackIndex() {
    return Math.round(ui.track.scrollLeft / (ui.track.clientWidth || 1));
  }

  function endProgrammatic() {
    state.target = null;
    clearTimeout(state.targetTimer);
  }

  function go(i, smooth) {
    var n = state.media.length;
    if (!n) return;
    i = Math.max(0, Math.min(n - 1, i));
    state.index = i;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var animate = smooth && !reduce && trackIndex() !== i;
    if (animate) {
      state.target = i;
      clearTimeout(state.targetTimer);
      // pojistka pro prohlížeče bez `scrollend` / přerušený posun prstem
      state.targetTimer = setTimeout(function () {
        endProgrammatic();
        var j = trackIndex();
        if (j !== state.index) { state.index = j; sync(); }
      }, 800);
    }
    ui.track.scrollTo({ left: i * ui.track.clientWidth, behavior: animate ? 'smooth' : 'auto' });
    sync();
  }

  /* data = recenze (null = galerie z hlavičky, recenzi bere syncPanel podle
     fotky), media = [{thumb, full, key, item?}] */
  function open(data, media, start, opener) {
    if (!dlg) build();
    state.opener = opener || document.activeElement;
    state.gallery = !data;
    state.panelItem = undefined;
    var hasMedia = media && media.length > 0;
    dlg.classList.toggle('tk-rvm--text', !hasMedia);
    dlg.classList.toggle('tk-rvm--photos', false);
    ui.media.hidden = !hasMedia;
    ui.panel.hidden = !data;
    if (data) fillPanel(data);
    state.index = start || 0;
    fillMedia(hasMedia ? media : [], state.index);
    syncPanel();
    document.documentElement.classList.add('tk-rvm-lock');
    dlg.showModal();
    ui.panel.scrollTop = 0;
    // pozice tracku až po layoutu otevřeného dialogu
    requestAnimationFrame(function () { go(state.index, false); });
  }

  function close() {
    if (dlg && dlg.open) dlg.close();
  }

  function onClosed() {
    endProgrammatic();
    ui.stage.style.height = '';
    document.documentElement.classList.remove('tk-rvm-lock');
    ui.track.textContent = '';
    var o = state.opener;
    state.opener = null;
    if (o && typeof o.focus === 'function' && document.contains(o)) o.focus({ preventScroll: true });
  }

  /* ── zachytávání kliků ve widgetu ─────────────────────────────────────── */
  function openItem(item, start, opener) {
    var data = readItem(item);
    open(data, data.media, start, opener);
  }

  /* Fotka v hlavičce → galerie VŠECH fotek ze všech recenzí (pořadí jako
     v hlavičce, videa vynechaná), u každé fotky její karta podle adresy. */
  function openFromHeader(btn) {
    var owner = {};
    document.querySelectorAll(WIDGET + ' .jm-review-item').forEach(function (item) {
      item.querySelectorAll('.jm-media-thumbnail-list__thumbnail img').forEach(function (img) {
        owner[mediaKey(img.getAttribute('src') || '')] = item;
      });
    });
    var grid = btn.closest('.jm-media-grid__container') || btn.parentNode;
    var media = [];
    var start = 0;
    grid.querySelectorAll('.jm-media-grid__item').forEach(function (b) {
      var img = b.querySelector('img');
      if (!img || hasVideo(b)) return;
      if (b === btn) start = media.length;
      var s = img.getAttribute('src') || '';
      var k = mediaKey(s);
      media.push({ thumb: urlWithWidth(s, 240), full: urlWithWidth(s, 1600), key: k, item: owner[k] || null });
    });
    if (!media.length) return false;
    open(null, media, start, btn);
    return true;
  }

  var INTERACTIVE = 'a, button, select, input, textarea, label, [role="button"], .jdgm-translate-button, .tk-verified-badge, .jm-voting-controls, .jm-shop-reply__expand-button';

  function handle(e, viaKey) {
    var t = e.target;
    if (!(t instanceof Element) || !t.closest(WIDGET)) return;

    var headerItem = t.closest('.jm-review-widget-header .jm-media-grid__item');
    if (headerItem) {
      if (hasVideo(headerItem)) return;
      if (openFromHeader(headerItem)) { e.preventDefault(); e.stopPropagation(); }
      return;
    }

    var item = t.closest('.jm-review-item');
    if (!item || hasVideo(item)) return;

    var thumb = t.closest('.jm-media-thumbnail-list__thumbnail');
    if (thumb) {
      var list = Array.prototype.slice.call(item.querySelectorAll('.jm-media-thumbnail-list__thumbnail'));
      e.preventDefault();
      e.stopPropagation();
      openItem(item, Math.max(0, list.indexOf(thumb)), thumb);
      return;
    }

    if (viaKey) {
      if (!t.classList.contains('tk-rv-open')) return;
    } else {
      if (t.closest(INTERACTIVE) && !t.closest('.tk-rv-open')) return;
      var sel = window.getSelection && window.getSelection();
      if (sel && String(sel).length > 0 && item.contains(sel.anchorNode)) return;
    }
    e.preventDefault();
    e.stopPropagation();
    openItem(item, 0, item.querySelector('.tk-rv-open') || item);
  }

  document.addEventListener('click', function (e) { handle(e, false); }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target;
    if (!(t instanceof Element)) return;
    // tlačítka (<button>) vyrobí click sama, keydown řešíme jen u role=button divů a titulku karty
    if (t.tagName === 'BUTTON') return;
    if (t.closest('.jm-media-thumbnail-list__thumbnail') || t.classList.contains('tk-rv-open')) handle(e, true);
  }, true);

  /* ── klávesnice: titulek karty = ovladač modalu ───────────────────────── */
  function decorate() {
    document.querySelectorAll(WIDGET + ' .jm-review-item').forEach(function (item) {
      if (item.hasAttribute('data-tk-rvm') || hasVideo(item)) return;
      item.setAttribute('data-tk-rvm', '1');
      item.classList.add('tk-rv-clickable');
      var target = item.querySelector('.jm-review-content__title') || item.querySelector('.jm-review-content__body');
      if (target) {
        target.classList.add('tk-rv-open');
        target.setAttribute('tabindex', '0');
        target.setAttribute('role', 'button');
        target.setAttribute('aria-haspopup', 'dialog');
      }
    });
  }

  function watch() {
    var root = document.querySelector(WIDGET);
    if (!root) return;
    decorate();
    var t = 0;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(decorate, 120);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
